export default {
  install: (app) => {
    app.directive('slider-tab', require('../directives/SliderTab.js').default)
    app.directive('table-mobile', require('../directives/TableMobile.js').default)
  }
}
